import TripDetail from "./TripDetail";
export default TripDetail



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripDetail/index.js